/* Common for Preview Profiles. */
export const data: any = {
  NEXT_PUBLIC_DEPLOYMENT_ENV: "development",
  NEXT_PUBLIC_CF_MXP_ENVIRONMENT: "master", // Contentful MXP Environment
  NEXT_PUBLIC_CF_RC_SPACE_ID: "jnzexz4x7lkk",
  NEXT_PUBLIC_CF_RC_ENVIRONMENT: "master",
  NEXT_PUBLIC_MODE: "live-preview",
  NEXT_PUBLIC_BASE_URL: "https://nofollow.trimble.com",
  NEXT_PUBLIC_SITEMAP_BASE_URL: "https://nofollow.trimble.com",
  NEXT_PUBLIC_RENDER_NAV: false,
  NEXT_PUBLIC_RENDER_FOOTER: false,
  NEXT_PUBLIC_ENABLE_SSG: false,
  NEXT_PUBLIC_PRERENDER_ARTICLES: false,
  NEXT_PUBLIC_PRERENDER_CASESTUDIES: false,
  NEXT_PUBLIC_PRERENDER_CUSTOMERSTORIES: false,
  NEXT_PUBLIC_PRERENDER_DOCS: false,
  NEXT_PUBLIC_PRERENDER_VIDEOS: false,
  NEXT_PUBLIC_PRERENDER_EXTERNAL_RESOURCES: false,
  NEXT_PUBLIC_PRERENDER_TAGS: false,
  NEXT_PUBLIC_PRERENDER_COLLECTIONS: false,
  NEXT_PUBLIC_PRERENDER_PAGES: false,
  NEXT_PUBLIC_PRERENDER_TRIMBLE_DEVELOPER: false,
  NEXT_PUBLIC_PREVIEW_DATA: true,
  NEXT_PUBLIC_ALGOLIA_APP_ID: "BGUNL6UMZR",
  NEXT_PUBLIC_ALGOLIA_API_KEY: "d391b07b54d358a1351edb9a348b4a75",
  NEXT_PUBLIC_ALGOLIA_GLOBAL_INDEX: "global-production",
  NEXT_PUBLIC_ALGOLIA_QS_INDEX: "global-production_query_suggestions",
  NEXT_PUBLIC_DISABLE_LANGUAGE_HANDLING: true,
  BYPASS_CONSENT_CHECK: true
}
